export enum DigipoortFlow {
    AanleverFault = 'AanleverFault',
    Happyflow = 'Happyflow',
    StatusInformatieFault = 'StatusInformatieFault',
    Afleverfout = 'Afleverfout',
    FoutUitvragendePartij = 'FoutUitvragendePartij',
    TechnischProbleemAfleveren = 'TechnischProbleemAfleveren',
    MaximaalAantalAfleverpogingen = 'MaximaalAantalAfleverpogingen',
    ZwaarbelastAanleveren = 'ZwaarbelastAanleveren',
    OverbelastAanleveren = 'OverbelastAanleveren',
    ZwaarbelastStatusInformatie = 'ZwaarbelastStatusInformatie',
    OverbelastStatusInformatie = 'OverbelastStatusInformatie'
}